import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { IconButton, Popover } from '@material-ui/core';
import { useAuth } from '../../../context/auth';
import { redirectOutside } from '../../../utilities';
import { UserAvatar } from '../UserAvatar';
import { AvatarPopperProps } from './AvatarPopper.interface';
import { 
  StyledPaper,
  LogoutButton,
  StyledDivider,
  UserWrapper,
  UserName,
  DovePointsWrapper,
  ListElement
} from './AvatarPopper.styles';

export function AvatarPopper({ user }: AvatarPopperProps) {
  const { logout, wallet } = useAuth();
  const history = useHistory();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popper' : undefined;
  
  const handleClick = (event:any) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  const handleClickLogout = () => {
    setAnchorEl(null);
    logout();
    return history.push(`${process.env.REACT_APP_INTERNAL_URL}`);
  }
  return (
    <>
      <IconButton onClick={handleClick} aria-label="Show notifications" color="inherit">
        <UserAvatar userName={user.displayName} size="40px" />
        {!user.isAdmin && 
          <DovePointsWrapper>
            <p>DovePoints</p>
            <p>{wallet ? wallet.availablePoints : 0}</p>
          </DovePointsWrapper>
        }
      </IconButton>
      <Popover 
        id={id} 
        open={open} 
        anchorEl={anchorEl} 
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <StyledPaper>
          <UserWrapper>
            <UserAvatar userName={user.displayName} size="50px" negative />
            <UserName>{user.displayName}</UserName>
          </UserWrapper>
          {!user.isAdmin && 
            <ListElement onClick={() => redirectOutside('/accounts')}>Go to DoveMed dashboard</ListElement>
          }
          <StyledDivider />
          <LogoutButton onClick={handleClickLogout}>Logout</LogoutButton>
        </StyledPaper>
      </Popover>
    </>
  );
}
